module.exports = __webpack_public_path__ + "img/glow-green-small.2659f51a.png";